import { Component, OnInit } from "@angular/core";
import { GroupsService } from "../../../../auth/service/group.service";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-groups-list",
  templateUrl: "./groups-list.component.html",
  styleUrls: ["./groups-list.component.scss"],
})
export class GroupsListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public currentUser: any = {};
  public searchKeyword: string = "";
  public searchStatus: number = 2;
  public groups: any = [];
  public owners_list: any = [];

  constructor(
    public _groupService: GroupsService,
    public _utilService: UtilsService,
    private _userService: UserService,
    public _authenticationService: AuthenticationService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    const headerTitle: string = await this._utilService.translate("MENU.GROUPS");
    this.contentHeader = {
      headerTitle,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: headerTitle,
            isLink: false,
          },
        ],
      },
    };

    this.owners_list = await this._userService.getList();
    await this.loadGroups();
    this._utilService.hideLoading();
  }

  async loadGroups() {
    this.groups = await this._groupService.getList().then((groups: any) => {
      return groups.map((group: any) => {
        group.owner = this.owners_list.find((user: any) => user.hash === group?.owner?.hash);
        group.members = group.users_list ? group.users_list.split(",") : [];
        group.members = this.owners_list.filter((user: any) => group.members.includes(user.hash));
        return group;
      });
    });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  groupsList() {
    let filtered: any = this.groups;

    const keyword: string = this.searchKeyword.toLowerCase().trim();
    if (keyword.length > 0) {
      filtered = filtered.filter((group: any) => group.name.toLowerCase().includes(keyword) || group.description.toLowerCase().includes(keyword) || JSON.stringify(group.members).toLowerCase().includes(keyword));
    }

    const enabled: any = Number(this.searchStatus);
    if (enabled < 2) {
      filtered = filtered.filter((group: any) => group.enabled === enabled);
    }

    return filtered;
  }

  async toggleEnabled(currentGroup) {
    if (!this._authenticationService.hasCapability("edit_group")) {
      window.history.back();
      return false;
    }
    const enabled: number = Boolean(currentGroup.enabled) ? 0 : 1;
    this._utilService.showLoading();
    await this._groupService
      .update(currentGroup.id, { enabled })
      .then(() => {
        this.loadGroups();
        if (enabled === 1) {
          this._utilService.showSWALSuccess({ text: "SUCCESS_ACTIVATED_GROUP" });
        } else {
          this._utilService.showSWALSuccess({ text: "SUCCESS_DISABLED_GROUP" });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_GROUP" });
      });
  }

  async delete(group: any) {
    if (!this._authenticationService.hasCapability("delete_group")) {
      window.history.back();
      return false;
    }
    if (group.used_in_users > 0 && group.enabled === 1) {
      await this._utilService.showSWALSuccess({ text: "USED_GROUP_TEXT" });
      return;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += group.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._groupService
            .delete(group.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_GROUP" }).then(async () => {
                await this.loadGroups();
              });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_GROUP" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_REMOVE_GROUP" });
      });
  }
}
